import {
  DailyAudioTrack,
  DailyVideo,
  useParticipantProperty,
} from "@daily-co/daily-react";
import { AudioLines } from "@tamagui/lucide-icons";

import { Heading, Text, XStack, YStack } from "@/components";

type CallPanelTileProps = {
  participantId: string;
  isSelf: boolean;
  name: string;
  // Placeholder graphic for an audio-only participant until we have a design
  audioOnly?: boolean;
  // Small tiles only have room for the audio-only icon
  compact?: boolean;
};

const CallPanelTile = ({
  participantId,
  isSelf,
  name,
  audioOnly = false,
  compact = false,
}: CallPanelTileProps) => {
  const [video] = useParticipantProperty(participantId, ["tracks.video"]);

  return (
    <>
      {video?.state === "playable" ? (
        <DailyVideo
          sessionId={participantId}
          type="video"
          automirror={isSelf}
          muted={isSelf}
          disablePictureInPicture
        />
      ) : audioOnly && compact ? (
        <YStack alignItems="center" justifyContent="center">
          <AudioLines aria-label={name} color="$neutral0" size="$300" />
        </YStack>
      ) : audioOnly ? (
        <YStack alignItems="center" justifyContent="center" gap="$50">
          <AudioLines color="$neutral0" size="$300" />
          <Heading color="$neutral0">{name}</Heading>
          <Text color="$neutral0">Audio only</Text>
        </YStack>
      ) : (
        <XStack alignItems="center" justifyContent="center" gap="$200">
          <Heading color="$neutral0">{name}</Heading>
        </XStack>
      )}
      {!isSelf && <DailyAudioTrack sessionId={participantId} />}
    </>
  );
};

export default CallPanelTile;
